import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { ZButton } from '@zanichelli/albe-web-components/react';
import { ButtonVariant, ControlSize } from '@zanichelli/albe-web-components';

export const ButtonsContainer = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: calc(var(--space-unit) * 4);

    & > z-button {
        width: 100%;
    }

    & > z-button:nth-child(2) {
        margin-top: calc(var(--space-unit) * 2);
    }

    @media (min-width: 768px) {
        flex-direction: row;

        & > z-button {
            width: auto;
        }

        & > z-button:nth-child(1) {
            margin-right: calc(var(--space-unit) * 2);
        }

        & > z-button:nth-child(2) {
            margin-top: 0;
        }
    }
`;

const Buttons = ({
    showPrimaryButton = true,
    primaryButtonText,
    primaryButtonDisabled = false,
    primaryButtonClick,
    showTertiaryButton = true,
    tertiaryButtonText,
    tertiaryButtonDisabled = false,
    tertiaryButtonClick,
}) => {
    return (
        <ButtonsContainer>
            {showPrimaryButton && (
                <ZButton
                    variant={ButtonVariant.PRIMARY}
                    size={ControlSize.SMALL}
                    disabled={primaryButtonDisabled}
                    onClick={primaryButtonClick}
                >
                    {primaryButtonText}
                </ZButton>
            )}
            {showTertiaryButton && (
                <ZButton
                    variant={ButtonVariant.TERTIARY}
                    size={ControlSize.SMALL}
                    disabled={tertiaryButtonDisabled}
                    onClick={tertiaryButtonClick}
                >
                    {tertiaryButtonText}
                </ZButton>
            )}
        </ButtonsContainer>
    );
};

Buttons.propTypes = {
    showPrimaryButton: PropTypes.bool,
    primaryButtonText: PropTypes.string,
    primaryButtonDisabled: PropTypes.bool,
    primaryButtonClick: PropTypes.func,
    showTertiaryButton: PropTypes.bool,
    tertiaryButtonText: PropTypes.string,
    tertiaryButtonDisabled: PropTypes.bool,
    tertiaryButtonClick: PropTypes.func,
};

export default Buttons;
